import React from 'react';

import { useEntity } from '@backstage/plugin-catalog-react';

import { Box } from '@material-ui/core';

import { PagerDutyTeamManageOwnership } from '../Components';

export const PagerDutyTeamActionContent = () => {
  const { entity } = useEntity();
  const hasOwnershipInfo = Boolean(
    entity.spec?.owner ||
      entity.metadata.annotations?.['tomtom.com/ownership-status'],
  );

  return (
    <Box display="flex" alignItems="center" flexWrap="wrap" gridGap={16}>
      {hasOwnershipInfo && <PagerDutyTeamManageOwnership />}
    </Box>
  );
};
